import axios from "axios";
import { joinURLs } from "../utils/urlUtil";
import { getHeadersConfig } from "../utils/config";
import { InventoryResponseDto } from "../utils/types";
import { ResponseStatus } from "../utils/types";
import { Dispatch, SetStateAction } from "react";
import ErrorHandler from "../utils/ErrorHandler";

interface InventoryParams {
  countryCode?: string,
  demandSourceId?: string,
  domain?: string
}
export const Inventory = {
  getInventory: async (demandSourceId: string, countryCode: string, domain: string, setInventoryResponseDto: Dispatch<SetStateAction<InventoryResponseDto | null>>, getInventoryAbortController: AbortController) => {
    const url = joinURLs("api/inventory/search", process.env.REACT_APP_JUPITER_API_BASE_URL);
    const params: InventoryParams = {};
    if (demandSourceId) {
      params.demandSourceId = demandSourceId;
    }
    if (domain) {
      params.domain = domain;
    }
    if (countryCode) {
      params.countryCode = countryCode;
    } else if (!params.demandSourceId && !params.domain) {
      params.countryCode = "us";
    }
    
    setInventoryResponseDto({
      status: ResponseStatus.LOADING,
      error: null,
      inventory: null,
    });

    try {
      const response = await axios.get(url, {
        ...getHeadersConfig(),
        params,
        withCredentials: true,
        signal: getInventoryAbortController.signal
      });
      if (response) {
        setInventoryResponseDto({
          status: ResponseStatus.OK, 
          error: null,
          inventory: response.data.inventory,
          count: response.data.count
        });
      }
    } catch (error:any) {
      // handle error
      console.log(error);

      if (!axios.isCancel(error)) {
        const isLoggedOut = ErrorHandler.handleAuthError(error);
        if (!isLoggedOut) {
          const responseDto: InventoryResponseDto = {
            status: ResponseStatus.ERROR, 
            error: error?.response?.data?.errorMessage || error?.message,
            inventory: null
          };
          setInventoryResponseDto(responseDto);
        }
      }
    }
  }
}
